import { DependencyList, useEffect, useState } from "react";

const useIsScrollableElement = (
  ref: React.RefObject<HTMLElement>,
  mode: "vertical" | "horizontal",
  ...dependencies: DependencyList
): boolean => {
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const checkIfScrollable = () => {
      if (ref.current) {
        const isHorizontalOverflowing =
          ref.current.scrollWidth > ref.current.clientWidth;
        const isVerticalOverflowing =
          ref.current.scrollHeight > ref.current.clientHeight;
        setIsScrollable(
          mode === "vertical" ? isVerticalOverflowing : isHorizontalOverflowing,
        );
      }
    };

    checkIfScrollable();

    window.addEventListener("resize", checkIfScrollable);

    return () => window.removeEventListener("resize", checkIfScrollable);
  }, [ref, mode, ...dependencies]);

  return isScrollable;
};

export default useIsScrollableElement;
